__turbopack_context__.v({
  "enter": "BlogMdxImage-module-scss-module__iRuQzq__enter",
  "exit": "BlogMdxImage-module-scss-module__iRuQzq__exit",
  "fade-in": "BlogMdxImage-module-scss-module__iRuQzq__fade-in",
  "fade-out": "BlogMdxImage-module-scss-module__iRuQzq__fade-out",
  "fade-out-80": "BlogMdxImage-module-scss-module__iRuQzq__fade-out-80",
  "image": "BlogMdxImage-module-scss-module__iRuQzq__image",
  "slide-in-from-bottom": "BlogMdxImage-module-scss-module__iRuQzq__slide-in-from-bottom",
  "slide-in-from-left": "BlogMdxImage-module-scss-module__iRuQzq__slide-in-from-left",
  "slide-in-from-right": "BlogMdxImage-module-scss-module__iRuQzq__slide-in-from-right",
  "slide-in-from-top": "BlogMdxImage-module-scss-module__iRuQzq__slide-in-from-top",
  "slide-out-to-bottom": "BlogMdxImage-module-scss-module__iRuQzq__slide-out-to-bottom",
  "slide-out-to-left": "BlogMdxImage-module-scss-module__iRuQzq__slide-out-to-left",
  "slide-out-to-right": "BlogMdxImage-module-scss-module__iRuQzq__slide-out-to-right",
  "slide-out-to-top": "BlogMdxImage-module-scss-module__iRuQzq__slide-out-to-top",
  "zoom-in": "BlogMdxImage-module-scss-module__iRuQzq__zoom-in",
  "zoom-out": "BlogMdxImage-module-scss-module__iRuQzq__zoom-out",
});
